import moment from 'moment'

class Tracker {
  constructor (options) {
    this.enabled = options.enabled

    window.addEventListener('load', () => {
      if (window.mixpanel) {
        window.mixpanel.init(process.env.MIXPANEL_TOKEN)
      }
      if (window.customerly) {
        window.customerly.load({
          app_id: process.env.CUSTOMERLY_APP_ID
        })
      }
    })
  }

  register (user) {
    if (this.enabled) {
      if (window.mixpanel) {
        window.mixpanel.alias('' + user.id)
      }
      if (window.customerly) {
        window.customerly.load({
          app_id: process.env.CUSTOMERLY_APP_ID,
          user_id: user.id,
          name: user.first_name + ' ' + user.last_name,
          email: user.email,
          attributes: {
            created_at: moment(user.created).format('X')
          }
        })
      }
    }
  }

  identify (user) {
    if (this.enabled) {
      if (window.mixpanel) {
        window.mixpanel.identify('' + user.id)
      }
      if (window.customerly) {
        window.customerly.load({
          app_id: process.env.CUSTOMERLY_APP_ID,
          user_id: user.id,
          name: user.first_name + ' ' + user.last_name,
          email: user.email,
          attributes: {
            created_at: moment(user.created).format('X')
          }
        })
      }
    }
  }

  track (event, props) {
    if (this.enabled) {
      if (window.mixpanel && window.mixpanel.track) {
        window.mixpanel.track(event, props)
      }
      if (window.customerly) {
        window.customerly.event(event)
      }
    }
  }
}

const TrackerPlugin = {
  install (Vue, options) {
    Vue.prototype.$tracker = new Tracker(options)
  }
}

export default TrackerPlugin
